import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {FlowCorrelationService} from './flow-correlation.service';

@Injectable()
export class CorrelationIdInterceptor implements HttpInterceptor {

  constructor(private flowCorrelationService: FlowCorrelationService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request.clone({
      setHeaders: this.flowCorrelationService.getCorrelationHeaders()
    }));
  }
}
